//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import { sendUserLog } from '@/utils/log'
export default {
    data () {
        return {
            src: '',
            title: '',
            cover_url: {}
        }
    },
    mounted () {
        console.log(111);
        const option = this.$route.query
        this.title = option.title
        setTimeout(() => {
            this.src = option.src
        }, 500)
        this.getData()
        sendUserLog('fc_building_video_view', {
            d_key: option.building_id,
            d_paras: {
                building_name: this.title,
                link: this.src
            },
            d_event: 0
        })
    },
    methods: {
        async getData () {
            const { building_id } = this.$route.query
            const data = await Service.getBuilding(building_id, {})
            this.cover_url = data.photos_urls && data.photos_urls.length ? data.photos_urls[0] : ''
        },
        error (err) {
            console.error(err)
        }
    }
}
